import { render, staticRenderFns } from "./Customer_payments.vue?vue&type=template&id=61811cd2&"
import script from "./Customer_payments.vue?vue&type=script&lang=js&"
export * from "./Customer_payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports